/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { CreateStations$Params, createStations } from '../fn/weather-station/create-stations';

/**
 * Weather Station API
 */
@Injectable({ providedIn: 'root' })
export class WeatherStationService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `createStations()` */
   static readonly CreateStationsPath = '/api/weather/weather_station';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `createStations()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   createStations$Response(params: CreateStations$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
      return createStations(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `createStations$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   createStations(params: CreateStations$Params, context?: HttpContext): Observable<{}> {
      return this.createStations$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
   }
}
